const initData = `
### To Do:
 - Hurrah! Nothing left to do!
`;

export default initData;
